const {
    API_CENTER,
    API_ENTERPRISE_NUMBER,
    CARD_CREDIT,
    CARD_DEBIT,
    CARD_ECARD,
    CARD_INTERVENTION_ADITIONAL_MEMBER,
    CARD_INTERVENTION_OWNER,
} = require('constants/index');
const { NERUDA_CARD_7_ON_STANDARD, NERUDA_CARD_7_OFF_STANDARD } = require('constants/cardNerudaStandardList');
const { R42_CARD_ON, R42_CARD_PENDING_DEACTIVATION } = require('constants/cardR42States');
const VALID_CARD = 'EN VIGOR';
const CANCELLED_CARD = 'CANCELADA';
const BLOCKED_CARD = 'BLOQUEADO';

// *** CONSTANTS ***

const cardConstants = {
    CARD_ACTIVATION: 'CARD_ACTIVATION',
    CARD_BENEFITS: 'CARD_BENEFITS',
    CARD_BLOCK: 'CARD_BLOCK',
    CARD_CHANGE_PAYMENT_METHOD: 'CARD_CHANGE_PAYMENT_METHOD',
    CARD_CHARGE: 'CARD_CHARGE',
    CARD_CONTROL_ON: 'CARD_CONTROL_ON',
    CARD_DEPOSIT_MONEY: 'CARD_DEPOSIT_MONEY',
    CARD_TRANSFER_MONEY: 'CARD_TRANSFER_MONEY',
    CARD_TRANSFER_TO_CHECKING_ACCOUNT_CC: 'CARD_TRANSFER_TO_CHECKING_ACCOUNT_CC',
    CARD_DETAILS: 'CARD_DETAILS',
    CARD_GET_ECARD_PDF: 'CARD_GET_ECARD_PDF',
    CARD_PIN_CHANGE: 'CARD_PIN_CHANGE',
    CARD_MOBILE_RECHARGE: 'CARD_MOBILE_RECHARGE',
    CARD_MODIFY_LIMIT: 'CARD_MODIFY_LIMIT',
    CARD_MODIFY_DEBIT_LIMITS: 'CARD_MODIFY_DEBIT_LIMITS',
    CARD_MOVEMENTS: 'CARD_MOVEMENTS',
    CARD_PAY_LATER: 'CARD_PAY_LATER',
    CARD_PAYMENT_PURCHASE_DEFERRAL: 'CARD_PAYMENT_PURCHASE_DEFERRAL',
    CARD_PIN_CVV_REQUEST: 'CARD_PIN_CVV_REQUEST',
    CARD_PIN_RESET: 'CARD_PIN_RESET',
    CARD_REPLACE: 'CARD_REPLACE',
    CARD_REWARD: 'CARD_REWARD',
    CARD_SECURE_PAYMENT: 'CARD_SECURE_PAYMENT',
    CARD_STATEMENT_INFORMATION: 'CARD_STATEMENT_INFORMATION',
    CARD_STATEMENT_MOVEMENTS: 'CARD_STATEMENT_MOVEMENTS',
    CARDS: 'CARDS',
    MODIFY_CARD_ACCOUNT: 'MODIFY_CARD_ACCOUNT',
    SEND_PIN: 'SEND_PIN',
    CARD_OPEN_YOUNG_MANAGEMENT: 'CARD_OPEN_YOUNG_MANAGEMENT',
    CARD_OPEN_YOUNG_UPLOAD_DOCUMENTATION: 'CARD_OPEN_YOUNG_UPLOAD_DOCUMENTATION',
    CHARITY_CARD: 'CHARITY_CARD',
    CARD_REQUEST_ADDITIONAL: 'CARD_REQUEST_ADDITIONAL',
};

const {
    CREDIT_CARD_REVOLVING_PROCESS,
} = require('constants/flagBasedFeatures');

// *** VALIDATION RULES ***
//TODO: cardpaymentPurchaseDefferral needs special logic

const defaultRedirectionURL = '/myprofile/cards';

const basicValidationRule = ({ immCard }) => !!immCard && !immCard.isEmpty(); //TODO: check this rule.
const isAdditionalCard = (card) => !!(card
    && card.get('interventionType')
    && card.get('interventionType') === 'MIEMBRO ADICIONAL');

const defaultValidationRule = {
    redirectURL: defaultRedirectionURL,
    validator: basicValidationRule
};

const isOpenbankAssociatedAccount = (immCard) => {
    const enterprise = immCard.getIn(['associatedAccountComplex', 'enterprise']);
    const center = immCard.getIn(['associatedAccountComplex', 'center']);
    return enterprise === API_ENTERPRISE_NUMBER && center === API_CENTER;
};

const depositMoneyValidation = {
    redirectURL: defaultRedirectionURL,
    validator: ({ immCard }) => {
        const isActive = immCard.get('active');
        if (!basicValidationRule({ immCard })) return false;
        if (!isActive) return false;
        const isViaT = immCard.get('isViaT');
        if (isViaT) return false;
        const validStatus = [BLOCKED_CARD, VALID_CARD];
        const type = immCard.get('type');
        const isValidCard = validStatus.includes(immCard.get('status'));
        const onState = immCard.get('control');
        let nerudaValidation = true;

        if (immCard.get('isNerudaCard') || immCard.get('isVanityCard') || immCard.get('isHormigueroCard')) {
            nerudaValidation = isOpenbankAssociatedAccount(immCard);
        }

        return onState && isValidCard && type === CARD_CREDIT && nerudaValidation;
    }
};


const transferMoneyValidation = {
    redirectURL: defaultRedirectionURL,
    validator: ({ immCard }) => {
        if (__CONTACT_CENTER__ || !basicValidationRule({ immCard })) return false;

        const validStatus = [BLOCKED_CARD, VALID_CARD];
        const type = immCard.get('type');
        const isViaT = immCard.get('isViaT');
        const isValidCard = validStatus.includes(immCard.get('status'));
        const onState = immCard.get('control');
        let nerudaValidation = true;

        if (immCard.get('isNerudaCard') || immCard.get('isVanityCard') || immCard.get('isHormigueroCard')) {
            nerudaValidation = isOpenbankAssociatedAccount(immCard);
        }

        return onState && isValidCard && type === CARD_CREDIT && !isViaT && nerudaValidation;
    }
}

const onlyCheckIfOperativeValidationRule = {
    redirectURL: defaultRedirectionURL,
    validator: ({ immCard }) => {
        if (!basicValidationRule({ immCard })) return false;

        const isValidCard = immCard.get('status') === VALID_CARD;

        return isValidCard;
    }
};

const cardValidationRules = {
    CARD_ACTIVATION: defaultValidationRule,
    CARD_BENEFITS: defaultValidationRule,
    CARD_BLOCK: onlyCheckIfOperativeValidationRule,
    CARD_CHANGE_PAYMENT_METHOD: {
        redirectURL: defaultRedirectionURL,
        validator: ({ immCard, immFlagBasedFeatures }) => {
            if ((immCard.get('isNerudaCard') || immCard.get('isVanityCard') || immCard.get('isHormigueroCard')) && !immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS)) {
                return false;
            }

            if (!basicValidationRule({ immCard })) {
                return false;
            }

            const type = immCard.get('type');
            const isActive = immCard.get('active');
            const interventionType = immCard.get('interventionType');
            const onState = immCard.get('control');
            const isValidCard = immCard.get('status') === VALID_CARD;
            const isLegalCard = immCard.get('isLegalCard');

            return isValidCard && isActive && onState && (interventionType === CARD_INTERVENTION_OWNER || isLegalCard) && type === CARD_CREDIT;
        }
    },
    CARD_CHARGE: {
        redirectURL: defaultRedirectionURL,
        validator: ({ immCard }) => {
            if (!basicValidationRule({ immCard })) return false;
            const isValidCard = immCard.get('status') === VALID_CARD;
            const isOpenYoung = immCard.get('isOpenYoung');
            const type = immCard.get('type');
            const isActive = immCard.get('active');
            const onState = immCard.get('control');

            return isValidCard && onState && isActive && (type === CARD_ECARD || isOpenYoung);
        }
    },
    CARD_CONTROL_ON: defaultValidationRule,
    CARD_DEPOSIT_MONEY: depositMoneyValidation,
    CARD_TRANSFER_MONEY: transferMoneyValidation,
    CARD_TRANSFER_TO_CHECKING_ACCOUNT_CC: {
        validator: ({ immCard }) => {
            if (!basicValidationRule({ immCard })) {
                return false;
            }

            const isOperative = immCard.get('isOperative');
            const controlOn = immCard.get('control');
            const type = immCard.get('type');
            const isCreditCard = type === CARD_CREDIT
            const isViaT = immCard.get('isViaT');
            const interventionType = immCard.get('interventionType');
            let nerudaValidation = true;

            if (immCard.get('isNerudaCard') || immCard.get('isVanityCard') || immCard.get('isHormigueroCard')) {
                nerudaValidation = isOpenbankAssociatedAccount(immCard);
            }

            return __CONTACT_CENTER__ && isOperative && controlOn && isCreditCard && interventionType === CARD_INTERVENTION_OWNER && !isViaT && nerudaValidation
        }
    },
    CARD_DETAILS: defaultValidationRule,
    CARD_PIN_CHANGE: {
        redirectURL: defaultRedirectionURL,
        validator: ({ immCard }) => {
            if (__CONTACT_CENTER__ || !basicValidationRule({ immCard })) return false;

            const isValidCard = immCard.get('status') === VALID_CARD;
            const isMinicard = !!immCard.get('isMinicard');
            const isActive = immCard.get('active');
            const onState = immCard.get('control');
            const isVirtualCredit = immCard.get('isVirtualCredit');
            const isVirtualDebit = immCard.get('isVirtualDebit');
            const isMetallic = immCard.get('isMetallic');
            const isPasssportDebit = immCard.get('isPassportDebit');

            return isValidCard && onState && isActive && (isMinicard || isVirtualCredit || isVirtualDebit || isPasssportDebit || isMetallic);
        }
    },
    CARD_MOBILE_RECHARGE: {
        redirectURL: defaultRedirectionURL,
        validator: ({ immCard }) => {
            if (__CONTACT_CENTER__ || !basicValidationRule({ immCard })) return false;
            const isValidCard = immCard.get('status') === VALID_CARD;
            const isViaT = immCard.get('isViaT');
            const isActive = immCard.get('active');
            const onState = immCard.get('control');

            return isValidCard && onState && !isViaT && isActive;
        }
    },
    CARD_MODIFY_LIMIT: {
        redirectURL: defaultRedirectionURL,
        validator: ({ immCard, isNerudaUser }) => {
            if (!basicValidationRule({ immCard }) || isNerudaUser) {
                return false;
            }

            const type = immCard.get('type');
            const interventionType = immCard.get('interventionType');
            const onState = immCard.get('control');
            const isValidCard = immCard.get('status') === VALID_CARD;
            const isLegalCard = immCard.get('isLegalCard');

            return isValidCard && onState && (interventionType === CARD_INTERVENTION_OWNER || isLegalCard) && type === CARD_CREDIT;
        }
    },
    CARD_MODIFY_DEBIT_LIMITS: {
        redirectURL: defaultRedirectionURL,
        validator: ({ immCard }) => {
            if (!basicValidationRule({ immCard })) return false;
            const onState = immCard.get('control');
            const isValidCard = immCard.get('status') === VALID_CARD;
            const isActive = immCard.get('active');
            const type = immCard.get('type');

            return isValidCard && isActive && onState && type === CARD_DEBIT;
        }
    },
    CARD_MOVEMENTS: defaultValidationRule,
    CARD_PAY_LATER: {
        redirectURL: ({ cardId, immCancelCardPayLater, __CONTACT_CENTER__ }) => {
            if (!__CONTACT_CENTER__) return defaultRedirectionURL;
            const hasPayLaterMovements = immCancelCardPayLater.get('hasPayLaterMovements');
            const isPayLater = hasPayLaterMovements && __CONTACT_CENTER__;
            return `/myprofile/cards/${cardId}/${isPayLater ? 'cancel-pay-later' : 'pay-later'}`;
        },
        validator: ({ immCard }) => {
            if (!basicValidationRule({ immCard })) return false;
            const type = immCard.get('type');
            const interventionType = immCard.get('interventionType');
            const isValidCard = immCard.get('status') === VALID_CARD;
            const isViaT = immCard.get('isViaT');
            const isLegalCard = immCard.get('isLegalCard');
            const onState = immCard.get('control');
            return isValidCard && onState && (interventionType === CARD_INTERVENTION_OWNER || isLegalCard) && type === CARD_CREDIT && !isViaT;
        }
    },
    CARD_PIN_CVV_REQUEST: {
        redirectURL: defaultRedirectionURL,
        validator: ({ immCard, isCVVRequest }) => {
            if (__CONTACT_CENTER__ || !basicValidationRule({ immCard })) return false;
            const onState = immCard.get('control');
            const isValidCard = immCard.get('status') === VALID_CARD;
            const type = immCard.get('type');
            const isOpenYoung = immCard.get('isOpenYoung');
            const isViaT = immCard.get('isViaT');
            const isActive = immCard.get('active');

            if (isCVVRequest) {
                return isValidCard && onState && isActive && !isViaT;
            } else {
                return isValidCard && onState && isActive && (isOpenYoung || type === CARD_DEBIT || type === CARD_CREDIT) && !isViaT;
            }
        }
    },
    CARD_PIN_RESET: {
        validator: ({ immCard }) => {
            if (!__CONTACT_CENTER__ || !basicValidationRule({ immCard })) return false;

            const isViaT = immCard.get('isViaT');
            if (__CONTACT_CENTER__ && isViaT) return false;

            const isActive = immCard.get('active');
            const isValidCard = immCard.get('status') === VALID_CARD;
            const isOwner = immCard.get('interventionType') === CARD_INTERVENTION_OWNER || immCard.get('interventionType') === CARD_INTERVENTION_ADITIONAL_MEMBER;
            const type = immCard.get('type');
            const isDebitOrCredit = type === CARD_DEBIT || type === CARD_CREDIT;
            const isMinicard = !!immCard.get('isMinicard');
            const isPremium = immCard.get('isPremium');
            const isDiamond = immCard.get('isDiamond');
            const isOpenYoung = immCard.get('isOpenYoung');

            const isRequiredType = isDebitOrCredit || isMinicard || isPremium || isDiamond || isOpenYoung;

            return isValidCard && isActive && isOwner && isRequiredType;
        }
    },
    CARD_DOWNLOAD_PDF: {
        redirectURL: defaultRedirectionURL,
        validator: ({ immCard }) => {
            if (__CONTACT_CENTER__ || !basicValidationRule({ immCard })) {
                return false;
            }
            const isActive = immCard.get('active');
            const onState = immCard.get('control');
            const isValidCard = immCard.get('status') === VALID_CARD;
            const isEcard = immCard.get('type') === CARD_ECARD;
            const isOpenYoung = immCard.get('isOpenYoung');
            const isVirtualDebit = immCard.get('isVirtualDebit');
            const isVirtualCredit = immCard.get('isVirtualCredit');

            const showCardMoreOptionsButton = isActive && (isEcard || isVirtualCredit || isVirtualDebit);
            return showCardMoreOptionsButton && isValidCard && onState && !isOpenYoung;
        }
    },
    CARD_REPLACE: {
        redirectURL: defaultRedirectionURL,
        validator: ({ immCard }) => {
            if (!basicValidationRule({ immCard })) return false;

            const validStatus = ['BAJA', 'CANCELADA', 'BLOQUEADO Y CAN'];
            const type = immCard.get('type');
            const status = immCard.get('status');
            const isViaT = immCard.get('isViaT');

            return type !== CARD_ECARD && !validStatus.includes(status) && !isViaT;
        }
    },
    CARD_REWARD: {
        redirectURL: defaultRedirectionURL,
        validator: ({ immCard }) => {
            const isNerudaCard = immCard.get('isNerudaCard');

            if (!basicValidationRule({ immCard })) return false;
            return isNerudaCard && ![NERUDA_CARD_7_ON_STANDARD, NERUDA_CARD_7_OFF_STANDARD].includes(immCard.getIn(['product', 'standard']));
        }
    },
    CARD_SECURE_PAYMENT: {
        redirectURL: defaultRedirectionURL,
        validator: ({ immCard }) => {
            if (!basicValidationRule({ immCard })) return false;

            const isValidCard = immCard.get('status') === VALID_CARD;
            const isViaT = immCard.get('isViaT');
            const onState = immCard.get('control');
            const isActive = immCard.get('active');

            return isValidCard && onState && isActive && !isViaT;
        }
    },
    CARD_STATEMENT_INFORMATION: defaultValidationRule,
    CARD_STATEMENT_MOVEMENTS: {
        redirectURL: defaultRedirectionURL,
        validator: ({ immCard }) => {

            if (!basicValidationRule({ immCard })) return false;
            if (isAdditionalCard(immCard) && [CANCELLED_CARD, BLOCKED_CARD].includes(immCard.get('status'))) return false;

            const type = immCard.get('type');
            const interventionType = immCard.get('interventionType');
            const isLegalCard = immCard.get('isLegalCard');

            return (interventionType === CARD_INTERVENTION_OWNER || isLegalCard) && type === CARD_CREDIT;
        }
    },
    CARDS: defaultValidationRule,
    CARD_BENEFITS_AND_POLICIES: {
        redirectURL: ({ immCard }) => {
            const isDiamond = immCard.get('isDiamond');
            const isPremium = immCard.get('isPremium');
            const cardId = immCard.get('cardId');

            let typeOfCard = 'r42';

            if (isDiamond) {
                typeOfCard = 'diamond';
            } else if (isPremium) {
                typeOfCard = 'premium';
            }

            return `/myprofile/cards/${cardId}/benefits/${typeOfCard}`;
        },
        validator: ({ immCard }) => {
            if (!basicValidationRule({ immCard })) return false;

            const isMetallic = immCard.get('isMetallic');
            const isravelPlus = immCard.getIn(['r42', 'travelSwitchVisible']);
            const vip = immCard.getIn(['r42', 'vip']);

            if (isravelPlus || isMetallic || vip) {
                return true
            }

        }
    },
    CARD_PAYMENT_PURCHASE_DEFERRAL: {
        redirectURL: defaultRedirectionURL,
        validator: ({ immCard }) => {
            if (!basicValidationRule({ immCard })) return false;

            const isValidCard = immCard.get('status') === 'EN VIGOR';
            const isViaT = immCard.get('isViaT');
            const onState = immCard.get('control');
            const interventionType = immCard.get('interventionType');
            const isLegalCard = immCard.get('isLegalCard');
            const isOwnerOfAdditional = immCard.get('isOwnerOfAdditional');

            return isValidCard && onState && (interventionType === CARD_INTERVENTION_OWNER || isLegalCard || isOwnerOfAdditional) && !isViaT;
        }
    },
    CARD_OPEN_YOUNG_MANAGEMENT: {
        redirectURL: defaultRedirectionURL,
        validator: ({ immCard }) => {
            if (!basicValidationRule({ immCard })) return false;

            const isValidCard = immCard.get('status') === VALID_CARD;
            const isOpenYoung = immCard.get('isOpenYoung');
            const isActive = immCard.get('active');
            const onState = immCard.get('control');

            return isValidCard && isActive && onState && isOpenYoung;
        }
    },
    CARD_OPEN_YOUNG_UPLOAD_DOCUMENTATION: {
        redirectURL: defaultRedirectionURL,
        validator: ({ immCard, immOpenYoungDocumentation }) => {
            if (!basicValidationRule({ immCard })) {
                return false;
            }

            const validDocumentationStates = ['2', '3', '4'];
            const hasDocumentationStateError = immOpenYoungDocumentation.get('error');
            const isValidDocumentationState = validDocumentationStates.includes(immOpenYoungDocumentation.getIn(['documentationState', 'state']));
            const isValidCard = immCard.get('status') === VALID_CARD;
            const isOpenYoung = immCard.get('isOpenYoung');
            const onState = immCard.get('control');

            return isValidCard && onState && isOpenYoung && (isValidDocumentationState || hasDocumentationStateError);
        }
    },
    CHARITY_CARD: {
        redirectURL: defaultRedirectionURL,
        validator: ({ immCard }) => {
            if (!basicValidationRule({ immCard })) {
                return false;
            }

            const isValidCard = immCard.get('status') === VALID_CARD;
            const isCharity = immCard.get('isCharity');
            const isActive = immCard.get('active');
            const onState = immCard.get('control');

            return isValidCard && isActive && onState && isCharity;
        }
    },
    MODIFY_CARD_ACCOUNT: {
        redirectURL: defaultRedirectionURL,
        validator: ({ immCard, isNerudaUser }) => {

            if (!basicValidationRule({ immCard }) || isNerudaUser) {
                return false;
            }

            const isOperative = immCard.get('isOperative');
            const isActive = immCard.get('active');
            const type = immCard.get('type');

            return isOperative && isActive && type === CARD_CREDIT && !immCard.get('isNerudaCard') && !immCard.get('isVanityCard') && !immCard.get('isHormigueroCard');
        }
    },
    SEND_PIN: {
        redirectURL: defaultRedirectionURL,
        validator: ({ immCard }) => {

            if (!basicValidationRule({ immCard })) return false;

            const isViaT = immCard.get('isViaT');
            if (__CONTACT_CENTER__ && isViaT) return false;

            const isRevolving = immCard.get('isRevolving');

            if (__CONTACT_CENTER__ && isRevolving) {
                return false;
            }

            const type = immCard.get('type');

            return type !== CARD_ECARD;
        }
    },
    CARD_REQUEST_ADDITIONAL: {
        redirectURL: defaultRedirectionURL,
        validator: ({ immCard, hideVirtualAdditionalCardForCC }) => {

            if (!__CONTACT_CENTER__ || !basicValidationRule({ immCard })) return false;

            const interventionType = immCard.get('interventionType');
            const type = immCard.get('type');
            const isOpenYoung = immCard.get('isOpenYoung');
            const isMinicard = !!immCard.get('isMinicard');
            const isViaT = immCard.get('isViaT');
            const isPassportDebit = immCard.get('isPassportDebit');

            let isVirtualAdditionalCardHidden;

            if (hideVirtualAdditionalCardForCC && (immCard.get('isVirtualCredit') || immCard.get('isVirtualDebit'))) {
                isVirtualAdditionalCardHidden = true;
            }

            return (interventionType === CARD_INTERVENTION_OWNER) && (type !== CARD_ECARD) &&
                !isOpenYoung && !isMinicard && !isViaT && !isPassportDebit && !isVirtualAdditionalCardHidden && !immCard.get('isNerudaCard') && !immCard.get('isVanityCard') && !immCard.get('isHormigueroCard');
        }
    }
};

module.exports = {
    cardConstants,
    cardValidationRules,
    isAdditionalCard
};
